export default __webpack_public_path__ + "static/media/11.3c262a61.jpeg";